<template>
  <div v-finger:swipe="swipe"
      :style="{
        width: containerWidth,
        height: containerHeight
      }"
      class="swiper-wrapper">
    <div class="swiper-inner"
      :style="{
        width: sliderWidth || '100%'
      }"
    >
      <slot />
    </div>
    <ul v-if="showNav" class="swiper-nav">
      <li
        v-for="i in size "
        :key="i"
        :class="{ selected: ((i-1) === currentIndex) }" >
      </li>
    </ul>
  </div>
</template>

<script>
import transform from '@/utils/transform'
import To from '@/utils/to'

export default {
  props: {
    containerWidth: String,
    containerHeight: String,
    sliderWidth: String,
    loop: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 500
    },
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentIndex: 0,
      size: 0,
      inited: false
    }
  },
  mounted () {
    this.init()
  },
  updated () {
    this.init()
  },
  methods: {
    init () {
      if (!this.inited && this.$el.querySelector('.swiper-slider')) {
        this.sliders = this.$el.querySelectorAll('.swiper-slider')
        this.size = this.sliders.length
        this.sliderScroll = this.$el.querySelector('.swiper-inner')
        this.wrapWidth = this.sliderScroll.offsetWidth
        this.moveTo = 0
        transform(this.sliderScroll)
        if (this.loop) {
          this.sliderScroll.innerHTML =
            this.sliders[this.size - 1].outerHTML +
            this.sliderScroll.innerHTML +
            this.sliders[0].outerHTML
          this.moveTo -= this.wrapWidth
          // eslint-disable-next-line
          new To(this.sliderScroll, 'translateX', this.moveTo, 0)
        }
        this.inited = true
      }
    },
    swipe (evt) {
      (evt.direction === 'Left') ? this.next() : this.prev()
    },
    next () {
      if (this.currentIndex <= this.size - 1) {
        this.moveTo -= this.wrapWidth
        // eslint-disable-next-line
        new To(this.sliderScroll, 'translateX', this.moveTo, this.duration, this.ease, () => {
          if (this.currentIndex === this.size - 1 && this.loop) {
            this.currentIndex = 0
            this.moveTo = -this.wrapWidth
            // eslint-disable-next-line
            new To(this.sliderScroll, 'translateX', this.moveTo, 0)
          } else {
            this.currentIndex++
          }
        })
      }
    },
    prev () {
      if (this.currentIndex >= 0) {
        this.moveTo += this.wrapWidth
        // eslint-disable-next-line
        new To(this.sliderScroll, 'translateX', this.moveTo, this.duration, this.ease, () => {
          if (this.currentIndex === 0 && this.loop) {
            this.currentIndex = this.size - 1
            this.moveTo = -this.wrapWidth * this.size
            // eslint-disable-next-line
            new To(this.sliderScroll, 'translateX', this.moveTo, 0)
          } else {
            this.currentIndex--
          }
        })
      }
    },
    ease (x) {
      return Math.sqrt(1 - Math.pow(x - 1, 2))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/swiper/swiper.vue